import * as React from "react"
import { PropsWithChildren } from "react"
import { PageProps } from "gatsby"
import { MDXProvider } from "@mdx-js/react"

import { PageLayout } from "./styles"
import { DefaultGlobalStyle } from "../styles"
import NavigationComponent from "../../components/core/navigation"
import FooterComponent from "../../components/core/footer"
import HeaderComponent, { HeaderConfig } from "../../components/shared/header"
import SectionComponent, { SectionConfig } from "../../components/shared/section"
import ButtonComponent, { ButtonConfig } from "../../components/shared/button"
import SeparatorComponent, { SeparatorConfig } from "../../components/shared/separator"
import SEOComponent from "../../components/core/seo"
import ContactComponent from "../../components/shared/contact"
import PartnersComponent, { PartnerConfig } from "../../components/shared/partners"
import ConferencesComponent, { ConferencesConfig } from "../../components/shared/conferences"

type Shortcodes<T = any> = { [key: string]: (props: PropsWithChildren<T>) => JSX.Element };

const shortcodes: Shortcodes<HeaderConfig | SectionConfig | ButtonConfig | SeparatorConfig | PartnerConfig[] | ConferencesConfig> = {
  Header: HeaderComponent,
  Section: SectionComponent,
  Partners: PartnersComponent,
  Button: ButtonComponent,
  Sep: SeparatorComponent,
  Contact: ContactComponent,
  ConferencesComponent: ConferencesComponent,
}

export default function Pages(props: PageProps) {
  return (
    <PageLayout>
      <DefaultGlobalStyle/>
      <SEOComponent lang={props.pageContext["langKey"]} title={props.pageContext['frontmatter'].title} />
      <NavigationComponent locale={props.pageContext["langKey"]}/>
      <MDXProvider
        components={shortcodes}>{props.children}</MDXProvider>
      <FooterComponent locale={props.pageContext["langKey"]}/>
    </PageLayout>
  )
}
